var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"stringInput",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.value)},on:{"blur":function (e) { return _vm.handleStringInput(e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }